export default function(key,arr,keyName){
        for(let i=0;i<arr.length;i++){
        if(arr[i][keyName]==key){
            return arr[i];
        }     
        }
        console.warn("cannot find key",arr,key,keyName);
    
}